import _ from 'lodash';
import { PRICE_SELECTED } from 'shared/data/quoteSteps';

export const extractFabrication = (arg) => {
  const { quoteStep, parameters, quote } = arg;
  if (quoteStep !== PRICE_SELECTED) return {};

  const {
    row_selected,
    column_selected,
  } = parameters;

  const lineItem = quote.line_items[0];
  if (!lineItem) return {};

  const price = _.round(lineItem.pricing[row_selected][column_selected], 2);
  const quantity = lineItem.quantities[row_selected];
  const leadTime = lineItem.lead_times[column_selected];

  const unitPrice = _.round((price / quantity), 2);

  return {
    quantity,
    leadTime,
    unitPrice,
    subTotal: price,
    selected: true,
  };
};
